import { VoidFunctionComponent } from 'react';
import ReactDatePicker from 'react-date-picker/dist/entry.nostyle';
import { getBrowserLocale } from 'lib/locale';
import { StyledDatePicker } from './DatePicker.styled';
import { DatePickerProps } from './types';

export const DatePicker: VoidFunctionComponent<DatePickerProps> = props => (
  <StyledDatePicker>
    <ReactDatePicker
      {...props}
      calendarIcon={null}
      locale={getBrowserLocale()}
      showLeadingZeros={true}
    />
  </StyledDatePicker>
);
